export interface IContactInfo {
    email?: string;
    phone?: string;
    web?: string;
    fax?: string;
}

export class ContactInfo implements IContactInfo {
    constructor(
        public email?: string,
        public phone?: string,
        public web?: string,
        public fax?: string
    ) {
        this.email = email ? email : '';
        this.web = web ? web : '';
        this.fax = fax ? fax : '';
        this.phone = phone ? phone : '';
    }
}
